import { Col, Flex, Radio, Row } from "antd";
import ButtonComponent from "components/button/Button";
import DropdownTriangle from "components/dropdown-triangle";
import InputComponent from "components/formInput/Input";
import Loading from "components/loading/Loading";
import PopupConfirm from "components/popup-confirm";
import { apiGetHelps, apiUpdateStatusHelps } from "helpers/api/faqs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { showToastError, showToastSuccess } from "utils";
import { HELP_ACTION, HELP_PLATFORM } from "./constants";
import Helps from "./help-items";
import "./styles.scss";

const HelpsList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [selected, setSelected] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [platform, setPlatform] = useState(HELP_PLATFORM.WEB);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [loading, setLoading] = useState(0);
  const [helps, setHelps] = useState({
    data: [],
    page: 1,
    total_items: 0,
    total_page: 0,
  });

  const getHelps = (newPage) => {
    setLoading((prev) => prev + 1);
    apiGetHelps({
      page: newPage || helps.page,
      limit: 15,
      key_search: searchInput,
      filter: `platform:${platform}`,
    })
      .then((res) => {
        if (res.error) {
          showToastError(res.error.message);
        } else {
          setHelps(res);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  const handleAction = (item) => {
    if (selected.length) {
      if (item.value === HELP_ACTION.DELETE) {
        setIsOpenDelete(true);
      } else {
        handleStatus(item.value);
      }
    }
  };

  const handleStatus = (type) => {
    setIsOpenDelete(false);
    setLoading((prev) => prev + 1);
    apiUpdateStatusHelps({
      faq_ids: selected,
      type,
    })
      .then((res) => {
        if (res.error) {
          showToastError(res.error.message);
        } else {
          if (type === HELP_ACTION.PUBLISH) {
            showToastSuccess("messages.MSG-USP056");
          }
          if (type === HELP_ACTION.UNPUBLISH) {
            showToastSuccess("messages.MSG-USP058");
          }
          if (type === HELP_ACTION.DELETE) {
            showToastSuccess("messages.MSG-USP040");
            if (selected.length === helps.data.length) {
              getHelps(1);
            } else {
              getHelps();
            }
            setSelected([]);
            return;
          }
          getHelps();
          setSelected([]);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  const onChangePlatform = ({ target: { value } }) => {
    setPlatform(value);
  };

  useEffect(() => {
    getHelps();
  }, [platform]);

  return (
    <div className="help-container main-content">
      <div className="root-right-header">
        <div className="screen-name">{t("admin_role")}</div>
      </div>
      <div className="nav">
        <Flex gap="large" wrap="wrap" align="center">
          <div className="screen-title">{t("helps.title")}</div>
          <DropdownTriangle
            options={[
              {
                title: "helps.publishSelectedArticles",
                value: HELP_ACTION.PUBLISH,
              },
              {
                title: "helps.hideSelectedArticles",
                value: HELP_ACTION.UNPUBLISH,
              },
              {
                title: "helps.deleteSelectedArticles",
                value: HELP_ACTION.DELETE,
              },
            ]}
            onClick={handleAction}
          />
        </Flex>
        <Row className="help-header">
          <Col md={7}>
            <InputComponent
              placeholder={t("search")}
              onChange={(e) => setSearchInput(e.target.value)}
              onEnter={() => getHelps(1)}
              suffix={
                <img
                  alt=""
                  src="/icons/search_img.png"
                  className="ic x2"
                  onClick={() => getHelps(1)}
                />
              }
            />
          </Col>
          <Col offset={1}>
            <ButtonComponent
              background="#B4E0F3"
              className="btn-create"
              text={t("helps.createArticle")}
              onClick={() => history.push("/admin/help-faqs/create")}
            />
          </Col>
          <Col>
            <Radio.Group
              options={[
                {
                  label: t("helps.form.clinicViewer"),
                  value: HELP_PLATFORM.WEB,
                },
                { label: t("helps.form.app"), value: HELP_PLATFORM.APP },
              ]}
              onChange={onChangePlatform}
              value={platform}
              optionType="button"
              buttonStyle="solid"
            />
          </Col>
        </Row>
      </div>
      <Helps data={helps.data} selected={selected} setSelected={setSelected} />
      { helps.data.length > 0 && 
      <Row
        style={{
          marginTop: "20px",
          justifyContent: "flex-end",
          padding: "0 20px",
        }}
      >
        <Col style={{ display: "flex" }}>
          {`${helps.page}/${helps.total_page} ${t("helps.page")}　`}
          <Flex gap="10px">
            {helps.page > 1 ? (
              <span
                style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                onClick={() => {
                  setHelps((prev) => ({ ...prev, page: prev.page - 1 }));
                  getHelps(helps.page - 1);
                }}
              >
                ▶
              </span>
            ) : null}
            {helps.page < helps.total_page ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setHelps((prev) => ({ ...prev, page: prev.page + 1 }));
                  getHelps(helps.page + 1);
                }}
              >
                ▶
              </span>
            ) : null}
          </Flex>
        </Col>
      </Row>
      }
      <PopupConfirm
        open={isOpenDelete}
        onCancelText={t("button.cancel")}
        onOkText={t("button.delete")}
        content={t("confirm_delete")}
        onOk={() => handleStatus(HELP_ACTION.DELETE)}
        onCancel={() => setIsOpenDelete(false)}
        onOkColor="#FF3131"
      />
      {loading ? <Loading /> : null}
    </div>
  );
};

export default HelpsList;
